import { TextField } from "material-ui";
import React from "react";
import { v4 as uuidv4 } from 'uuid';

export default function BasicInput({ 
    value,
    onChange,
    floatingLabelStyle = {}, 
    style = {},
    underlineStyle = {},
    name,
    type,
    onBlur = () => {},
}) {

    return (
        <TextField 
            name={name + uuidv4()}
            value={value || ''}
            onChange={onChange}
            floatingLabelStyle={floatingLabelStyle}
            style={{ width: '100%', ...style}}
            underlineStyle={underlineStyle}
            type={type}
            onBlur={onBlur}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/Basic/BasicInput.jsx